import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ShipmentExportToFileStart } from './shipment-export.actions';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportFileFacade } from '../../../../../common/models';
import { ListSearchCriteriaFacade } from '../../../list-search-criteria/list-search-criteria.facade';
import { ListSearchCriteriaType } from '../../../list-search-criteria/constants/list-search-criteria-type.constant';
import { ShipmentListSearchCriteria } from '../models/shipment.model';
import { ExportDialogComponent } from '../../../../../ui-kit/export-dialog';
import { ExportType } from '../../../../constants';

@Injectable({ providedIn: 'root' })
export class ShipmentExportFacade implements ExportFileFacade {
  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  startExportToFile(
    reportName: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
    addressExport: string,
    reportType: ExportType,
  ): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Shipment)
      .subscribe((searchCriteria: ShipmentListSearchCriteria) => {
        const { viewMode, filters, shipmentStatisticFilter } = searchCriteria;
        this.store.dispatch(
          new ShipmentExportToFileStart({
            reportName,
            searchRequestView: {
              filter: filters,
              statisticFilter: shipmentStatisticFilter,
              viewMode,
            },
            dialogRef,
            navigationNeeded,
            reportType,
          }),
        );
      });
  }
}
